import {
  CreateTrackingDeviceAssignmentRequest,
  RetrieveTrackingDeviceAssignmentsRequest
} from './device-assignment.types';

import { API_HOST, HttpGetOptions, HttpPostOptions, getHttpGetOptions, getHttpPostOptions } from '../../utils/api.util';

const getEndpoint = (systemUserExternalReference: string) =>
  `${API_HOST}/system-users/${systemUserExternalReference}/tracking-device-assignment`;

export const getCreateTrackingDeviceAssignmentRequest = (
  data: CreateTrackingDeviceAssignmentRequest
): [string, HttpPostOptions<{ deviceId: string }>] => [
  getEndpoint(data.systemUserExternalReference),
  getHttpPostOptions({ deviceId: data.deviceId })
];

export const getRetrieveTrackingDeviceAssignmentsRequest = (
  data: RetrieveTrackingDeviceAssignmentsRequest
): [string, HttpGetOptions] => [getEndpoint(data.systemUserExternalReference), getHttpGetOptions()];
